import { z } from "zod";

export const CancelMagicLinkProcessInputSchema = z.object({
    requestId: z.string(),
});

export type CancelMagicLinkProcessInput = z.infer<typeof CancelMagicLinkProcessInputSchema>;

